export const FETCH_ACTIVITY_DETAILS_REQUEST = 'FETCH_ACTIVITY_DETAILS_REQUEST';
export const FETCH_ACTIVITY_DETAILS_SUCCESS = 'FETCH_ACTIVITY_DETAILS_SUCCESS';
export const FETCH_ACTIVITY_DETAILS_FAILURE = 'FETCH_ACTIVITY_DETAILS_FAILURE';
